import React from "react";

export function isOralEmbedded() {
  return window.self !== window.top;
}

export default function OralVoiceRecovery({ error, onRetry, embedded = isOralEmbedded() }) {
  if (!error) return null;
  const microphone = error.stage === "opening_microphone";
  return (
    <div className="oral-voice-recovery" role="alert">
      <p>{microphone
        ? `We couldn’t open the microphone${embedded ? " in this embedded page" : ""}. Check your browser’s microphone permission, then try again.`
        : `We couldn’t start voice${embedded ? " in this embedded page" : ""}. Check your connection, then try again.`}</p>
      <button type="button" onClick={onRetry}>Try again</button>
      {embedded && <>
        <a href="https://schools.articulate.com.sg/oral-exam-voice-embed" target="_blank" rel="noopener noreferrer">Open the Oral Examiner directly</a>
        <p>The direct link opens a separate page. It does not transfer this session. To retry this session, use Try again.</p>
      </>}
    </div>
  );
}
